import { getMdContentParsed } from 'utils';
import changelog from 'CHANGELOG.md';

export const releaseNotesContent = getMdContentParsed(changelog);

export const currentVersion = releaseNotesContent?.[0]?.version;
